<template>
    <div>
        <div>
            <div v-for="stat in _stats" :key="stat[0]" class="stat_line mb-2">
                <span class="stat_line_title">{{ stat[0] }}</span>
                <b-progress :max="stat[1]" style="flex: 1;">
                    <!-- <b-progress-bar class="bad_count" :value="total - stat[1]">
                        <a href="#">{{ total - stat[1] }} ({{  (((total - stat[1]) / total) * 100).toFixed(2) }}%)</a>
                    </b-progress-bar>
                    <b-progress-bar class="good_count" :value="stat[1]">
                        <a href="#">{{ stat[1] }} ({{  ((stat[1] / total) * 100).toFixed(2) }}%)</a>
                    </b-progress-bar> -->
                    <b-progress-bar class="bad_count" :value="stat[2]">
                        <span>{{ bad_count(stat) }}</span>
                    </b-progress-bar>
                    <b-progress-bar class="good_count" :value="stat[1] - stat[2]">
                        <span>{{ good_count(stat) }}</span>
                    </b-progress-bar>
                </b-progress>
            </div>
        </div>
        
        <div v-if="good_stat_legend || bad_stat_legend" class="d-flex pb-3 legend-container" style="gap: 2.5rem;">
            <div class="d-flex align-items-center"><div class="legend bad"></div>
            <span>{{ bad_stat_legend }}</span></div>
            <div class="d-flex align-items-center"><div class="legend good"></div>
            <span>{{ good_stat_legend }}</span></div>
        </div>
    </div>
</template>

<script>
export default {
    props:
    {
        stats : Array,
        total : { type : Number, default : () => null },
        good_stat_legend : { type : String, default : () => null },
        bad_stat_legend : { type : String, default : () => null  },
    },

    computed :
    {
        _stats() {
            return this.stats.filter((stat) => stat[2] || stat[2] === 0)
        }
    },

    methods :
    {
        bad_count(stat)
        {
            return `${ stat[2] } (${
                stat[1] === 0
                ? 0
                : (((stat[2]) / (stat[1])) * 100).toFixed(2)
            }%)`
        },

        good_count(stat)
        {
            return `${ stat[1] - stat[2] } (${
                stat[1] === 0
                ? 0
                : (((stat[1] - stat[2]) / (stat[1])) * 100).toFixed(2)
            }%)`
        }
    }
}
</script>

<style scoped>
.stat_line
{
    display: flex;
    align-items: center;
}

.stat_line_title
{
    width: 40%;
    font-size: .75rem;
}

.progress
{
    height: fit-content;
    position: relative;
}

.progress-bar
{
    height: 1.5rem;
}

.progress-bar span
{
    position: absolute;
}

.progress-bar.bad_count, .legend.bad
{
    background-color: var(--bft-blue-200);
}

.progress-bar.good_count span
{
    color: white;
    right: 8px;
}

.progress-bar.bad_count span
{
    color: var(--bft-neutral-900);
    margin-inline: .5rem auto;
}

.legend-container
{
    font-size: .75rem;
}

.legend
{
    width: .5rem;
    height: 1rem;
    border-radius: 53px;
    margin-right: 1.5rem;
}

.progress-bar.good_count, .legend.good
{
    background-color: var(--bft-blue-500);
}
</style>
